import { operationTypes } from '@utils/statuses';

const DEFAULT_FILTER_EXCLUDE_KEYS = ['end_date', 'filter'];

export const calculateFiltersCount = (
  params,
  filters,
  extraExcludeKeys = [],
) => {
  const excludeKeys = [...DEFAULT_FILTER_EXCLUDE_KEYS, ...extraExcludeKeys];
  return Object.keys(filters).filter((key) => {
    if (excludeKeys.includes(key)) return false;
    const value = params[key];
    return value !== null && value !== undefined && value !== '';
  }).length;
};

export const filterOperationTypes = (filter) => {
  return operationTypes.filter((type) => type.filter?.includes(filter));
};

/* Команды для селектов в фильтрах: активные группой сверху, удалённые ниже.
   rsuite строит группы в порядке появления элементов, поэтому важна сортировка. */
export const groupTeamsByStatus = (teams = [], t) => {
  const active = teams.filter((item) => !item.deleted_at);
  const deleted = teams.filter((item) => item.deleted_at);

  return [
    ...active.map((item) => ({ ...item, group: t('active_groups') })),
    ...deleted.map((item) => ({ ...item, group: t('deleted_groups') })),
  ];
};
